(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.classList.add('header-wrapper--sticky');
        const headerElement = this.querySelector('.header');
        if (headerElement) {
          headerElement.style.borderRadius = '0';
          headerElement.style.margin = '0';
        }
      };

      this.setActiveMenuItem();
      this.setupMobileMenu();
      this.setupDropdownBehavior();
      this.setupHoverEffects(); // NEW: Setup hover effects

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    
    // NEW: Setup hover effects for both dropdowns and mobile menu
    setupHoverEffects() {
      this.setupDropdownHover();
      this.setupMobileMenuHover();
    }

    // NEW: Setup dropdown hover functionality
    setupDropdownHover() {
      const dropdowns = this.querySelectorAll('.dropdown-details');
      let activeDropdown = null;
      let hoverTimeout = null;

      dropdowns.forEach(dropdown => {
        const submenu = dropdown.querySelector('.header__submenu');

        // Disable default details/summary behavior
        const summary = dropdown.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', (e) => {
            e.preventDefault();
          });
        }

        // Mouse enter on dropdown
        dropdown.addEventListener('mouseenter', () => {
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            hoverTimeout = null;
          }

          // Close other dropdowns
          if (activeDropdown && activeDropdown !== dropdown) {
            activeDropdown.classList.remove('hover-active');
            activeDropdown.open = false;
          }

          // Open this dropdown
          dropdown.classList.add('hover-active');
          dropdown.open = true;
          activeDropdown = dropdown;
        });

        // Mouse leave on dropdown
        dropdown.addEventListener('mouseleave', () => {
          hoverTimeout = setTimeout(() => {
            dropdown.classList.remove('hover-active');
            dropdown.open = false;
            if (activeDropdown === dropdown) {
              activeDropdown = null;
            }
          }, 150); // Small delay to prevent flickering
        });

        // Keep dropdown open when hovering over submenu
        if (submenu) {
          submenu.addEventListener('mouseenter', () => {
            if (hoverTimeout) {
              clearTimeout(hoverTimeout);
              hoverTimeout = null;
            }
          });

          submenu.addEventListener('mouseleave', () => {
            hoverTimeout = setTimeout(() => {
              dropdown.classList.remove('hover-active');
              dropdown.open = false;
              if (activeDropdown === dropdown) {
                activeDropdown = null;
              }
            }, 150);
          });
        }
      });

      // Close all dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.dropdown-details')) {
          dropdowns.forEach(dropdown => {
            dropdown.classList.remove('hover-active');
            dropdown.open = false;
          });
          activeDropdown = null;
        }
      });
    }

    // NEW: Setup mobile menu hover functionality
    setupMobileMenuHover() {
      const menuToggleContainer = document.getElementById('mobile-menu-toggle-container');
      const menuToggle = document.getElementById('MenuToggle');
      const mobileMenu = document.getElementById('MobileMenu');
      const drawerOverlay = document.getElementById('DrawerOverlay');
      let hoverTimeout = null;

      if (!menuToggleContainer || !menuToggle || !mobileMenu) return;

      // Only activate hover effects on desktop/tablet screens (not mobile)
      const checkScreenSize = () => window.innerWidth > 989; // Changed from <= 989 to > 989

      const openMobileMenuHover = () => {
        if (!checkScreenSize()) return; // Only work on desktop
        
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        
        mobileMenu.classList.add('is-open');
        if (drawerOverlay) drawerOverlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
        menuToggle.setAttribute('aria-expanded', 'true');
      };

      const closeMobileMenuHover = () => {
        if (!checkScreenSize()) return; // Only work on desktop
        
        hoverTimeout = setTimeout(() => {
          mobileMenu.classList.remove('is-open');
          if (drawerOverlay) drawerOverlay.classList.remove('is-visible');
          document.body.style.overflow = '';
          menuToggle.setAttribute('aria-expanded', 'false');
        }, 200);
      };

      // Hover on menu toggle - only on desktop
      menuToggleContainer.addEventListener('mouseenter', () => {
        if (checkScreenSize()) {
          openMobileMenuHover();
        }
      });

      menuToggleContainer.addEventListener('mouseleave', () => {
        if (checkScreenSize()) {
          closeMobileMenuHover();
        }
      });

      // Hover on mobile menu itself - only on desktop
      mobileMenu.addEventListener('mouseenter', () => {
        if (checkScreenSize() && hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
      });

      mobileMenu.addEventListener('mouseleave', () => {
        if (checkScreenSize()) {
          closeMobileMenuHover();
        }
      });

      // Clear timeout on resize
      window.addEventListener('resize', () => {
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        // Close mobile menu if window becomes too large
        if (window.innerWidth > 989 && mobileMenu.classList.contains('is-open')) {
          mobileMenu.classList.remove('is-open');
          if (drawerOverlay) drawerOverlay.classList.remove('is-visible');
          document.body.style.overflow = '';
        }
      });
    }
    
    // Enhanced dropdown behavior - only one dropdown open at a time
    setupDropdownBehavior() {
      const dropdowns = this.querySelectorAll('.header__inline-menu details');
      
      dropdowns.forEach(dropdown => {
        dropdown.addEventListener('toggle', (e) => {
          if (e.target.open) {
            // Close all other dropdowns when this one opens
            dropdowns.forEach(otherDropdown => {
              if (otherDropdown !== e.target && otherDropdown.open) {
                otherDropdown.open = false;
                otherDropdown.classList.remove('hover-active');
              }
            });
          }
        });
      });
    }
    
    setActiveMenuItem() {
      const currentPath = window.location.pathname;
      const menuItems = document.querySelectorAll('.list-menu__item--link');
      
      menuItems.forEach(item => {
        const itemPath = item.getAttribute('href');
        if (itemPath) {
          if (itemPath === currentPath || (itemPath !== '/' && currentPath.includes(itemPath))) {
            item.classList.add('active');
          }
        }
      });
    }
    
    setupMobileMenu() {
      const menuToggle = document.getElementById('MenuToggle');
      const mobileMenu = document.getElementById('MobileMenu');
      const drawerOverlay = document.getElementById('DrawerOverlay');
      const drawerClose = document.getElementById('DrawerClose');
      let currentSubmenu = null;
      
      if (menuToggle && mobileMenu && drawerOverlay && drawerClose) {
        // Click functionality remains as backup
        menuToggle.addEventListener('click', (e) => {
          e.preventDefault();
          if (mobileMenu.classList.contains('is-open')) {
            this.closeMobileMenu();
          } else {
            mobileMenu.classList.add('is-open');
            drawerOverlay.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
            menuToggle.setAttribute('aria-expanded', 'true');
          }
          this.cleanupErrorText();
        });
        
        const closeMenu = () => {
          this.closeMobileMenu();
        };
        
        drawerClose.addEventListener('click', closeMenu);
        drawerOverlay.addEventListener('click', closeMenu);

        // Global functions for submenu navigation
        window.openSubmenu = function(submenuId, title) {
          const mainMenu = document.getElementById('main-menu-level');
          const submenu = document.getElementById(submenuId);
          
          if (submenu) {
            mainMenu.classList.remove('active');
            submenu.classList.add('active');
            currentSubmenu = submenuId;
          }
        }

        window.closeSubmenu = function() {
          const mainMenu = document.getElementById('main-menu-level');
          
          if (currentSubmenu) {
            const submenu = document.getElementById(currentSubmenu);
            if (submenu) {
              submenu.classList.remove('active');
            }
            currentSubmenu = null;
          }
          
          mainMenu.classList.add('active');
        }
        
        this.cleanupErrorText();
      }
    }

    // NEW: Close mobile menu method
    closeMobileMenu() {
      const menuToggle = document.getElementById('MenuToggle');
      const mobileMenu = document.getElementById('MobileMenu');
      const drawerOverlay = document.getElementById('DrawerOverlay');
      
      if (mobileMenu && drawerOverlay && menuToggle) {
        mobileMenu.classList.remove('is-open');
        drawerOverlay.classList.remove('is-visible');
        document.body.style.overflow = '';
        menuToggle.setAttribute('aria-expanded', 'false');
        
        // Reset to main menu when closing
        const currentSubmenu = document.querySelector('.menu-level.active:not(.main-menu)');
        if (currentSubmenu) {
          window.closeSubmenu();
        }
      }
    }
    
    cleanupErrorText() {
      const findErrorTextAndRemove = (element) => {
        if (!element) return;
        
        for (let i = 0; i < element.childNodes.length; i++) {
          const node = element.childNodes[i];
          
          if (node.nodeType === 3 && 
              (node.textContent.includes('{"title"') || 
               node.textContent.includes('"Create account"') ||
               node.textContent.includes('{title') ||
               node.textContent.match(/[\{\}"\=\>]+/g))) {
            element.removeChild(node);
            continue;
          }
          
          if (node.nodeType === 1) {
            findErrorTextAndRemove(node);
          }
        }
      };
      
      findErrorTextAndRemove(document.getElementById('MobileMenu'));
      findErrorTextAndRemove(document.querySelector('.drawer__mobile-nav'));
      findErrorTextAndRemove(document.querySelector('.mobile-menu__account-links'));
      
      document.querySelectorAll('div, p, span, pre').forEach(el => {
        if (el.childNodes.length === 1 && 
            el.childNodes[0].nodeType === 3 && 
            el.childNodes[0].textContent.match(/[\{\}"\=\>]+/g)) {
          el.style.display = 'none';
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.classList.remove('header-wrapper--sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.classList.add('header-wrapper--sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.classList.remove('header-wrapper--sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Search Modal Functionality
  class SearchModal {
    constructor() {
      this.currentPage = 1;
      this.itemsPerPage = 6;
      this.totalResults = 0;
      this.allResults = [];
      this.currentQuery = '';
      this.init();
    }
  
    init() {
      this.createModal();
      this.bindEvents();
    }
  
    createModal() {
      const modalHTML = `
        <div id="searchModal" class="search-modal">
          <div class="search-modal__container">
            <div class="search-modal__header">
              <input 
                type="text" 
                id="searchInput" 
                class="search-modal__input" 
                placeholder="Search products and articles..."
                autocomplete="off"
              >
              <button class="search-modal__close" aria-label="Close search">×</button>
            </div>
            <div class="search-modal__body">
              <div id="searchResults" class="search-modal__results"></div>
              <div id="searchPagination" class="search-modal__pagination"></div>
            </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    }
  
    bindEvents() {
      const searchTriggers = document.querySelectorAll('[href*="search"], .header__icon--search, .search-trigger');
      const modal = document.getElementById('searchModal');
      const searchInput = document.getElementById('searchInput');
      const closeBtn = document.querySelector('.search-modal__close');
  
      // Open modal
      searchTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal();
        });
      });
  
      // Close modal
      closeBtn?.addEventListener('click', () => this.closeModal());
      modal?.addEventListener('click', (e) => {
        if (e.target === modal) this.closeModal();
      });
  
      // ESC key close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal?.classList.contains('search-modal--active')) {
          this.closeModal();
        }
      });
  
      // Search on input
      let searchTimeout;
      searchInput?.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const query = e.target.value.trim();
        
        if (query.length >= 2) {
          searchTimeout = setTimeout(() => {
            this.currentPage = 1;
            this.performSearch(query);
          }, 300);
        } else {
          this.clearResults();
        }
      });
    }
  
    openModal() {
      const modal = document.getElementById('searchModal');
      const searchInput = document.getElementById('searchInput');
      
      modal?.classList.add('search-modal--active');
      document.body.style.overflow = 'hidden';
      
      setTimeout(() => {
        searchInput?.focus();
      }, 100);
    }
  
    closeModal() {
      const modal = document.getElementById('searchModal');
      modal?.classList.remove('search-modal--active');
      document.body.style.overflow = '';
      this.clearResults();
      document.getElementById('searchInput').value = '';
    }
  
    async performSearch(query) {
      this.currentQuery = query;
      
      try {
        const resultsContainer = document.getElementById('searchResults');
        resultsContainer.innerHTML = '<div class="search-modal__loading">Searching...</div>';
  
        // Use predictive search API for more results
        const searchResponse = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article&resources[limit]=50&resources[options][unavailable_products]=last&resources[options][fields]=title,body,product_type,tag,variants.title`);
        
        if (!searchResponse.ok) {
          throw new Error('Search failed');
        }
  
        const searchData = await searchResponse.json();
        
        // Extract products and articles from the response
        const products = searchData.resources?.results?.products || [];
        const articles = searchData.resources?.results?.articles || [];
        
        // If we got fewer than 20 total results, try additional searches with variations
        let allProducts = [...products];
        let allArticles = [...articles];
        
        if ((products.length + articles.length) < 20 && query.length > 2) {
          // Try partial matching and related searches
          const additionalSearches = [];
          
          // Search with wildcards and partial terms
          const searchTerms = [
            `${query}*`,  // wildcard
            query.split(' ')[0], // first word only
            query.slice(0, -1), // remove last character
          ];
          
          for (const term of searchTerms) {
            if (term !== query && term.length > 1) {
              additionalSearches.push(
                fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,article&resources[limit]=30`)
                  .then(res => res.json())
                  .catch(() => ({ resources: { results: { products: [], articles: [] } } }))
              );
            }
          }
          
          if (additionalSearches.length > 0) {
            const additionalResults = await Promise.all(additionalSearches);
            
            additionalResults.forEach(result => {
              const newProducts = result.resources?.results?.products || [];
              const newArticles = result.resources?.results?.articles || [];
              
              // Add products that aren't already included
              newProducts.forEach(product => {
                if (!allProducts.some(p => p.id === product.id)) {
                  allProducts.push(product);
                }
              });
              
              // Add articles that aren't already included
              newArticles.forEach(article => {
                if (!allArticles.some(a => a.id === article.id)) {
                  allArticles.push(article);
                }
              });
            });
          }
        }
  
        // Combine and format all results
        this.allResults = [
          ...allProducts.map(product => ({
            type: 'product',
            title: product.title,
            url: product.url,
            image: product.image || product.featured_image,
            id: product.id,
            relevance: this.calculateRelevance(product.title, query)
          })),
          ...allArticles.map(article => ({
            type: 'article',
            title: article.title,
            url: article.url,
            image: article.image || article.featured_image,
            id: article.id,
            summary: article.summary || article.excerpt,
            published_at: article.published_at,
            relevance: this.calculateRelevance(article.title, query)
          }))
        ];
  
        // Sort by relevance (exact matches first, then partial matches)
        this.allResults.sort((a, b) => b.relevance - a.relevance);
  
        this.totalResults = this.allResults.length;
        this.displayResults();
        this.displayPagination();
  
      } catch (error) {
        console.error('Search error:', error);
        document.getElementById('searchResults').innerHTML = 
          '<div class="search-modal__error">Search temporarily unavailable. Please try again.</div>';
      }
    }
  
    calculateRelevance(title, query) {
      const titleLower = title.toLowerCase();
      const queryLower = query.toLowerCase();
      
      // Exact match gets highest score
      if (titleLower.includes(queryLower)) {
        return 100;
      }
      
      // Partial word matches
      const queryWords = queryLower.split(' ');
      let score = 0;
      
      queryWords.forEach(word => {
        if (titleLower.includes(word)) {
          score += 50;
        }
      });
      
      return score;
    }
  
    displayResults() {
      const resultsContainer = document.getElementById('searchResults');
      
      if (!this.allResults.length) {
        resultsContainer.innerHTML = `
          <div class="search-modal__results-empty">
            No results found for "${this.currentQuery}". Try different keywords.
          </div>
        `;
        return;
      }
  
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const pageResults = this.allResults.slice(startIndex, endIndex);
  
      const resultsHTML = pageResults.map(item => {
        const image = item.image ? item.image : '';
        
        if (item.type === 'product') {
          return `
            <div class="search-modal__result-item search-modal__result-item--product">
              <a href="${item.url}" class="search-modal__result-link">
                ${image ? `<img src="${image}" alt="${item.title}" class="search-modal__result-image">` : '<div class="search-modal__result-image search-modal__result-image--placeholder"></div>'}
                <div class="search-modal__result-content">
                  <div class="search-modal__result-title">${item.title}</div>
                  <div class="search-modal__result-type">Product</div>
                </div>
              </a>
            </div>
          `;
        } else {
          return `
            <div class="search-modal__result-item search-modal__result-item--article">
              <a href="${item.url}" class="search-modal__result-link">
                ${image ? `<img src="${image}" alt="${item.title}" class="search-modal__result-image">` : '<div class="search-modal__result-image search-modal__result-image--placeholder"></div>'}
                <div class="search-modal__result-content">
                  <div class="search-modal__result-title">${item.title}</div>
                  <div class="search-modal__result-type">Article</div>
                  ${item.summary ? `<div class="search-modal__result-summary">${item.summary.substring(0, 100)}...</div>` : ''}
                </div>
              </a>
            </div>
          `;
        }
      }).join('');
  
      resultsContainer.innerHTML = `
        <div class="search-modal__results-header">
          <span class="search-modal__results-count">
            Showing ${startIndex + 1}-${Math.min(endIndex, this.totalResults)} of ${this.totalResults} results
          </span>
        </div>
        <div class="search-modal__results-list">
          ${resultsHTML}
        </div>
      `;
    }
  
    displayPagination() {
      const paginationContainer = document.getElementById('searchPagination');
      const totalPages = Math.ceil(this.totalResults / this.itemsPerPage);
  
      if (totalPages <= 1) {
        paginationContainer.innerHTML = '';
        return;
      }
  
      let paginationHTML = '<div class="search-modal__pagination-controls">';
  
      // Previous button
      if (this.currentPage > 1) {
        paginationHTML += `<button class="search-modal__pagination-btn" onclick="searchModalInstance.goToPage(${this.currentPage - 1})">‹ Previous</button>`;
      }
  
      // Page numbers
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(totalPages, this.currentPage + 2);
  
      if (startPage > 1) {
        paginationHTML += `<button class="search-modal__pagination-btn" onclick="searchModalInstance.goToPage(1)">1</button>`;
        if (startPage > 2) {
          paginationHTML += '<span class="search-modal__pagination-dots">...</span>';
        }
      }
  
      for (let i = startPage; i <= endPage; i++) {
        const activeClass = i === this.currentPage ? 'search-modal__pagination-btn--active' : '';
        paginationHTML += `<button class="search-modal__pagination-btn ${activeClass}" onclick="searchModalInstance.goToPage(${i})">${i}</button>`;
      }
  
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          paginationHTML += '<span class="search-modal__pagination-dots">...</span>';
        }
        paginationHTML += `<button class="search-modal__pagination-btn" onclick="searchModalInstance.goToPage(${totalPages})">${totalPages}</button>`;
      }
  
      // Next button
      if (this.currentPage < totalPages) {
        paginationHTML += `<button class="search-modal__pagination-btn" onclick="searchModalInstance.goToPage(${this.currentPage + 1})">Next ›</button>`;
      }
  
      paginationHTML += '</div>';
      paginationContainer.innerHTML = paginationHTML;
    }
  
    goToPage(page) {
      this.currentPage = page;
      this.displayResults();
      this.displayPagination();
      
      // Scroll to top of results
      document.querySelector('.search-modal__results').scrollTop = 0;
    }
  
    clearResults() {
      document.getElementById('searchResults').innerHTML = '';
      document.getElementById('searchPagination').innerHTML = '';
      this.allResults = [];
      this.totalResults = 0;
      this.currentPage = 1;
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.searchModalInstance = new SearchModal();
  });

  } catch(e) { console.error(e); }
})();
})();
